import { gql } from "@apollo/client";

export const DeleteFeatures = gql`
mutation DeleteFeatures($idStore: ID!) {
  deleteFeatures(idStore: $idStore) {
    status
  }
}
`;
